// extracted by mini-css-extract-plugin
export default {"container":"ProductCard_container__EoJS7","productIcon":"ProductCard_productIcon__Hf0VE","arrowIcon":"ProductCard_arrowIcon__9sUQE"};